import { useState } from "react";
import { Navigate } from "react-router-dom";
import LogoStyle from "../../components/Logo";
import { useUserContext } from "../../contexts/UserContext";
import { FaPlus } from "react-icons/fa";
import {
  ContainerHeader,
  ContainerInfos,
  ContainerUser,
  Header,
  Loading,
} from "./style";
import ListTechs from "../../components/ListTechs";
import Modal from "../../components/Modal";

const Dashboard = () => {
  const { navigate, user, loading } = useUserContext();
  const [showModal, setShowModal] = useState(false);

  if (loading) {
    return <Loading>Carregando...</Loading>;
  }

  const closeModal = () => {
    setShowModal(false);
  };

  const logout = () => {
    window.localStorage.removeItem("@kenzieHubToken");
    navigate("/");
  };

  return (
    <>
      {user ? (
        <>
          <Header>
            <ContainerHeader>
              <LogoStyle> Kenzie Hub </LogoStyle>
              <button type="button" onClick={() => logout()}>
                Sair
              </button>
            </ContainerHeader>
          </Header>
          <ContainerUser>
            <div>
              <h2>{user.name}</h2>
              <p>{user.course_module}</p>
            </div>
          </ContainerUser>
          <ContainerInfos>
            <div>
              <h2>Tecnologias</h2>
              <button onClick={() => setShowModal(true)}>
                <FaPlus />
              </button>
            </div>
          </ContainerInfos>
          <ListTechs />
          {showModal && <Modal closeModal={closeModal} />}
        </>
      ) : (
        <Navigate to="/" />
      )}
    </>
  );
};

export default Dashboard;
